import request from "../../../utils/request";

// 列表
export const getLotteryItemList = (params) => {
  return request({
    method: "GET",
    path: "/admin-management/getLotteryItemList",
    params,
  });
};

// 获取活动参与人员
export const getLotteryPeopleList = (params) => {
  return request({
    method: "GET",
    path: "/admin-management/getLotteryPeopleList",
    params,
  });
};

// 保存活动预参与人员
export const setLotteryPeopleList = (params) => {
  return request({
    method: "POST",
    path: "/admin-management/setLotteryPrePeopleList",
    params,
  });
};